import React from 'react';

import {SkeletonItem} from './skeleton-item';

type Props = {
    labelWidth: number,
};

export const InputSkeleton = ({labelWidth}: Props) => (
    <SkeletonItem width={labelWidth} height={32}/>
);
